import moment from 'moment'

export default (reseller) => {
    return JSON.parse(JSON.stringify({
        date: moment().format('YYYY-MM-DD'),
        name: '',
        customerId: '',
        messengerId: '',
        plannedStartTime: '',
        plannedEndTime: '',
        startShiftBeforeStartTime: '',
        startShiftBeforeStartTimeMargin: 0,
        routeTemplateIds: [],
        startPoint: reseller?.settings ? {...reseller.settings.companyAddress} : undefined,
        endPoint: reseller?.settings ? {...reseller.settings.companyAddress} : undefined,
        instructions: '',
        targets: [],
        meta: {},
        lateStartSettings: {
            warning: 'default'
        }
    }))
}
